import FireflyZigZag from '@/components/icons/FireflyZigZag';
import { BillSize, FaAnswers } from '@/state/state.types';
import { useLgBreakpoint } from '@/theme/hooks/useLgBreakpoint';
import { useMdBreakpoint } from '@/theme/hooks/useMdBreakpoint';
import { Flex, useMantineTheme } from '@mantine/core';
import { Dispatch, SetStateAction } from 'react';
import { useFields } from '../hooks/useFields';
import { FinancialAidActions } from './FinancialAidActions';
import { FinancialAidBullets } from './FinancialAidBullets';
import { FinancialAidHero } from './FinancialAidHero';
import { PartnerAttribution } from './PartnerAttribution';

interface Props {
  isPartnershipPreset: boolean;
  partnership: string;
  logoSrc?: string;
  firstName: string;
  lastName: string;
  isLoading: boolean;
  setAnswer: Dispatch<SetStateAction<'' | FaAnswers>>;
}

const FinancialAidStep = ({
  isPartnershipPreset,
  partnership,
  logoSrc,
  isLoading,
  setAnswer,
}: Props) => {
  const theme = useMantineTheme();
  const isMdBreakpoint = useMdBreakpoint();
  const isLgBreakpoint = useLgBreakpoint();
  const fields = useFields();
  const isLessThan5k = BillSize.Values['less-than-5k'] === fields?.['bill-size'];
  const showConciergeFallback = !isLessThan5k;

  return (
    <>
      <Flex
        w="100%"
        wrap="wrap"
        justify="center"
        align="center"
        my="auto"
        rowGap={50}
        direction={isLgBreakpoint ? 'row' : 'column'}
      >
        <Flex
          direction="column"
          align="flex-start"
          justify="center"
          bg="primary.0"
          gap={32}
          style={{
            boxShadow: `0 0 0 100vmax ${theme.colors.primary[0]}`,
            alignSelf: 'center',
            width: isMdBreakpoint ? 'auto' : '100%',
          }}
        >
          <Flex
            maw={610}
            direction="column"
            align="flex-start"
            justify="center"
            gap={32}
            style={{
              zIndex: 1,
            }}
          >
            <FinancialAidHero />
            <FinancialAidBullets
              isPartnershipPreset={isPartnershipPreset}
              partnership={partnership}
            />
            <FinancialAidActions
              isLoading={isLoading}
              showBottomLink={showConciergeFallback}
              setAnswer={setAnswer}
            />
          </Flex>
        </Flex>
        <FireflyZigZag
          shouldFocus={false}
          isLgBreakpoint={isLgBreakpoint}
          isMdBreakpoint={isMdBreakpoint}
        />
      </Flex>
      {isPartnershipPreset && (
        <Flex
          pos="absolute"
          top={'20%'}
          right={'28%'}
          style={{ zIndex: 9999 }}
        >
          <PartnerAttribution
            partnership={partnership}
            logoSrc={logoSrc}
          />
        </Flex>
      )}
    </>
  );
};

export default FinancialAidStep;
